import { useCheckPermission } from "misc/customHooks";
import { PermissionValues } from "misc/permission.types";
import { ReactNode } from "react";

type PermissionViewPropsType = {
  neededPermissions: PermissionValues[];
  children: ReactNode;
  checkType?: "some" | "every";
};

function PermissionView(props: PermissionViewPropsType) {
  const { neededPermissions, children, checkType = "some" } = props;
  const checkPermission = useCheckPermission();

  const hasPermission = checkPermission(neededPermissions, checkType);

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
}

export default PermissionView;
